import "core-js/modules/es.array.includes.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-13f3444e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "LogicalReasoningRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin": "30px"
  }
}, " 每个题目中会呈现一个有 9-10 个小立方体构成的立体图形，选项中会呈现六个类似的立体图形，其中只有一个或两个是由题目中的图形旋转得到的，它与题目中的立体图形完全相同，只是呈现的角度不同。 请你想象题目中图形旋转后，能够得到哪个图形，请把它选出来。 请在保证正确性的情况下尽快作答。 ", -1));
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  class: "left"
};
const _hoisted_6 = {
  class: "right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_button = _resolveComponent("el-button");
  return $props.data ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_image, {
    style: {
      "width": "250px",
      "height": "250px"
    },
    src: $props.runtimeParams[$props.data.questionIndex].question
  }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.runtimeParams[$props.data.questionIndex]?.answers, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: {
        "display": "flex",
        "flex-direction": "column",
        "margin": "5px"
      }
    }, [_createVNode(_component_el_image, {
      src: item ?? '',
      style: {
        "width": "220px",
        "height": "220px"
      }
    }, null, 8, ["src"]), _createVNode(_component_el_button, {
      disabled: $props.reviewMode,
      type: $data.select.includes(String.fromCharCode(65 + index)) ? 'primary' : '',
      style: {
        "margin-top": "10px"
      },
      onClick: $event => $options.onChoosed(String.fromCharCode(65 + index))
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(String.fromCharCode(65 + index)), 1)]),
      _: 2
    }, 1032, ["disabled", "type", "onClick"])]);
  }), 128))])]), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "flex flex-col bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswer), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      style: _normalizeStyle({
        color: $props.review.result ? 'green' : 'red'
      })
    }, "您的答案：" + _toDisplayString($props.review.answer), 5)) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}